import axios from '@axios'

const route = 'sales'

export default {
  namespaced: true,
  withStatus: true,
  employeeDefault: {},
  state: {
    pdv: true,
    widthDialog: '1250',
    dialog: false, // dialog de nova venda
    dialogPdvFast: false, // dialog pdv rápido
    paymentCompleted: false, // dialog de pagamento concluído
    dialogInvoice: false, // dialog de fatura
    invoice: {
      date_sale: null,
      customer_id: null,
      sale_item: [],
      payment: {
        payment_item: [],
      },
    },
    searchCustomer: false,
    customer: null,
    checkout: [],
    gratuities: [],
    dialogEditGratuity: false,
    selectedGratuity: null,
    tax: 0,
    stage: 'new_sale', // new_sale ;gratuity ;payment ; multiple_payment_methods
    paymentMethods: [],
    note: {},
    sale_id: null,
    showCheckout: true,
    orderService: null,
    allowEditSale: true,
  },
  getters: {
    /**
     * retorna se a venda pode ser editada
     */
    getAllowEditSale(state) {
      return state.allowEditSale
    },

    /**
     * pega a ordem de serviço (comanda)
     */
    getOrderService(state) {
      return state.orderService
    },

    getWidthDialog(state) {
      return state.widthDialog
    },
    getPdv(state) {
      return state.pdv
    },
    getInvoice(state) {
      return state.invoice
    },
    getDialogInvoice(state) {
      return state.dialogInvoice
    },
    getPaymentCompleted(state) {
      return state.paymentCompleted
    },
    getDialogSearchCustomer(state) {
      return state.searchCustomer
    },
    getEmployeeDefault(state) {
      return state.employeeDefault
    },
    getItemsCheckout(state) {
      return state.checkout
    },
    getNote(state) {
      return state.note
    },
    getCustomer(state) {
      return state.customer
    },
    getStage(state) {
      return state.stage
    },
    getSubtotal(state) {
      // soma todos os produtos
      return state.checkout.reduce((accumalator, item) => accumalator + item.sale_price * item.qtd_checkout, 0)
    },
    getTotal(state) {
      // soma todos os produtos
      state.subTotal = state.checkout.reduce(
        (accumalator, item) => accumalator + item.sale_price * item.qtd_checkout,
        0,
      )

      return state.tax + state.subTotal
    },
    getTotalToPay(state) {
      // soma todos os produtos
      const subTotal = state.checkout.reduce(
        (accumalator, item) => accumalator + item.sale_price * item.qtd_checkout,
        0,
      )

      // soma todas as gorjetas
      const gratuity = state.gratuities.reduce((accumalator, item) => accumalator + parseFloat(item.value), 0)

      return state.tax + subTotal + gratuity
    },
    getpaymentMethods(state) {
      return state.paymentMethods
    },
    remainingValue(state, getters) {
      const sumPayment = state.paymentMethods.reduce((sum, payment) => sum + parseFloat(payment.value), 0)

      return sumPayment - getters.getTotalToPay
    },
    getGratuities(state) {
      return state.gratuities
    },
    getDialogEditGratuity(state) {
      return state.dialogEditGratuity
    },
    getSelectedGratuity(state) {
      return state.selectedGratuity
    },
    getShowCheckout(state) {
      return state.showCheckout
    },
    getDialog(state) {
      return state.dialog
    },
    getDialogPdvFast(state) {
      return state.dialogPdvFast
    },
    emptyCheckout(state) {
      if (state.checkout.length > 0) {
        return false
      }

      return true
    },
  },
  mutations: {
    /**
     * seta se a venda pode ser editada
     */
    setAllowEditSale(state, allowEditSale) {
      state.allowEditSale = allowEditSale
    },

    /**
     * seta a ordem de serviço (comanda)
     */
    setOrderService(state, orderService) {
      state.orderService = orderService
    },

    setWidthDialog(state, widthDialog) {
      state.widthDialog = widthDialog
    },
    setPdv(state, pdv) {
      state.pdv = pdv
    },
    setInvoice(state, invoice) {
      state.invoice = invoice
    },
    setDialogInvoice(state, dialogInvoice) {
      state.dialogInvoice = dialogInvoice
    },
    setPaymentCompleted(state, paymentCompleted) {
      state.paymentCompleted = paymentCompleted
    },
    setDialogSearchCustomer(state, searchCustomer) {
      state.searchCustomer = searchCustomer
    },
    setDialog(state, dialog) {
      state.dialog = dialog
    },
    setDialogPdvFast(state, dialogPdvFast) {
      state.dialogPdvFast = dialogPdvFast
    },
    setEmployeeDefault(state, employee) {
      state.employeeDefault = employee
    },

    cancelSale(state) {
      state.customer = null
      state.checkout = []
      state.orderService = null
      state.gratuities = []
      state.tax = 0
      state.stage = 'new_sale'
      state.paymentMethods = []
      state.sale_id = null
      state.showCheckout = true
    },
    setShowCheckout(state, showCheckout) {
      state.showCheckout = showCheckout
    },
    setNote(state, note) {
      state.note = note
    },

    setDialogEditGratuity(state, dialogEditGratuity) {
      state.dialogEditGratuity = dialogEditGratuity
    },
    setGratuities(state, gratuities) {
      state.gratuities = gratuities
    },
    setSelectedGratuity(state, selectedGratuity) {
      state.selectedGratuity = selectedGratuity
    },

    setCustomer(state, customer) {
      state.customer = customer

      // state.showCheckout = true
    },
    removeCustomer(state) {
      state.customer = null

      // if (state.checkout.length > 0){
      //   state.customer = {id:1,name:'Cliente Padrão'}
      // }else{
      //   state.customer =null
      // }
    },

    addPaymentMethod(state, payment) {
      if (payment.clearPayments) {
        // limpa todos os pagamnetos
        state.paymentMethods = []
      }
      const paymentMethod = state.paymentMethods.find(item => payment.method == item.method)

      if (paymentMethod != undefined) {
        state.paymentMethods.splice(state.paymentMethods.indexOf(paymentMethod), 1) // apaga o method de pagamento
      }

      state.paymentMethods.push(payment) // adicona pagamento
    },

    removePaymentMethod(state, payment) {
      state.paymentMethods.splice(state.paymentMethods.indexOf(payment), 1)
    },
    setCheckout(state, checkout) {
      state.checkout = [] // gambiarra pra força reacao do vue
      state.checkout = checkout
    },
    addCheckout(state, item) {
      // localizar o item no checkout
      const search_item = state.checkout.find(
        search_item => search_item.id == item.id && search_item.origin_checkout == item.origin_checkout,
      )

      // se nao encontrar adiciona novo item
      if (item.origin_checkout == 'service') {
        item.qtd_checkout = 1
        state.checkout.push(item)
      } else if (search_item == undefined) {
        item.qtd_checkout = 1
        state.checkout.push(item)
      } else {
        // se encontrar soma a quantidade
        const index = state.checkout.findIndex(ci => ci.id == item.id && ci.origin_checkout == item.origin_checkout)
        if (index !== -1) {
          state.checkout[index].qtd_checkout += 1
        }
      }

      // if (state.customer == null) {
      //   state.customer = { id: 1, name: 'Cliente Padrão' }
      // }

      state.showCheckout = true

      // gambiarra para força a a reacao do vue
      const { checkout } = state
      state.checkout = null
      state.checkout = checkout
    },

    setStage(state, stage) {
      state.stage = stage
    },
    clearSale(state) {
      state.customer = null
      state.checkout = []
      state.orderService = null
      state.gratuities = []
      state.dialogEditGratuity = false
      state.selectedGratuity = 6
      state.tax = 0
      state.stage = 'new_sale'
      state.paymentMethods = []
      state.note = {}
      state.showCheckout = true
      state.invoice = {
        date_sale: null,
        customer_id: null,
        sale_item: [],
        payment: {
          payment_item: [],
        },
      }
      state.paymentCompleted = false // dialog de pagamento concluído
      state.dialogInvoice = false // dialog de fatura
      state.allowEditSale = true
    },
  },
  actions: {
    printTerm(context, saleId) {
      return axios.get(`${route}/print_term/${saleId}`)
    },

    /**
     *  carrega a visualizacao do compon para imprimir
     */
    getViewPrint(context, saleId) {
      return axios.get(`${route}/print_view/${saleId}`)
    },

    /**
     * carrega informacoes do caixa
     */
    getInfoCash(context) {
      return axios.post('sales/info_pdv')
    },

    loadEmployeeDefault(context) {
      return axios.get('helper/get_employee_default').then(response => {
        context.commit('setEmployeeDefault', response.data)
      })
    },
    searchCustomer(context, search) {
      return axios.get(`${route}/search_customers/${search}`)
    },
    getSearchItems(context, search) {
      return axios.get(`${route}/search_items/${search}`)
    },
    storeFastSales(context, items) {
      return axios.post(`${route}/items_fast_sales`, items)
    },
    getFastSales(context) {
      return axios.get(`${route}/load_items_fast_sales`)
    },

    /**
     * verifica se o caixa esta aberto
     */
    getCashOpened(context) {
      return axios.get('cash/current_cash')
    },

    loadCardOptions(context) {
      return axios.get('helper/get_card')
    },
    getOrderService(context, orderId) {
      return axios.get(`${route}/orderservice/${orderId}`)
    },

    /**
     *  carrega os serviços para venda
     */
    getServices(context, payload) {
      return axios.get(`helper/get_services?search=${payload.search}`)
    },

    /**
     *  carrega os produtos para venda
     */
    getProducts(context, payload) {
      return axios.get(`${route}/get_products`, {
        params: {
          search: payload.search,
          category_id: payload.categoryId,
        },
      })
    },

    getProductCategories() {
      return axios.get('helper/get_category_product')
    },

    loadOrderService(context, orderId) {
      return axios.get(`${route}/orderservice/${orderId}`).then(response => {
        context.commit('setOrderService', response.data)

        return response.data
      })
    },
    saveUnpaid({ state }) {
      const sale = {
        customer: state.customer,
        checkout: state.checkout,
        gratuities: state.gratuities,
        tax: state.tax,
        stage: state.stage,
        paymentMethods: state.paymentMethods,
        note: state.note,
        sale_id: state.sale_id,
      }

      return axios.post(`${route}/save_unpaind`, sale)
    },
    storeSale({ state }) {
      const sale = {
        customer: state.customer,
        checkout: state.checkout,
        gratuities: state.gratuities,
        tax: state.tax,
        stage: state.stage,
        paymentMethods: state.paymentMethods,
        note: state.note,
        sale_id: state.sale_id,
        orderService: state.orderService,
      }

      return axios.post(`${route}/store_sale`, sale)
    },
  },
}
